export default __webpack_public_path__ + "static/media/Head_4_Ear_2_C3.de66e464.svg";